import { render, staticRenderFns } from "./minform.vue?vue&type=template&id=c13300ce&"
import script from "./minform.vue?vue&type=script&lang=js&"
export * from "./minform.vue?vue&type=script&lang=js&"
import style0 from "./minform.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports